import { createSlice } from '@reduxjs/toolkit';
import { Auth } from '../../apis/common/auth';

const initialState = {
    isInitialized: false,
    refreshToken: null,
    accessToken: null,
    user: null
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        initialize: (state) => {
            state.isInitialized = true;
            state.refreshToken = Auth.getRefreshToken();
            state.accessToken = Auth.getAccessToken();
            state.user = Auth.getUser();
        },
        setSession: (state, action) => {
            const { data } = action.payload;
            state.isInitialized = true;
            state.refreshToken = data.refreshToken;
            state.accessToken = data.accessToken;
            state.user = data.user;
            Auth.setRefreshToken(data.refreshToken);
            Auth.setAccessToken(data.accessToken);
            Auth.setUser(data.user);
        },
        clear: (state) => {
            state.isInitialized = true;
            state.refreshToken = null;
            state.accessToken = null;
            state.user = null;
            Auth.clear();
        }
    }
});

// State
export const isInitialized = (state) => state.auth.isInitialized;
export const refreshToken = (state) => state.auth.refreshToken;
export const accessToken = (state) => state.auth.accessToken;
export const user = (state) => state.auth.user;

// Actions
export const { initialize, setSession, clear } = authSlice.actions;

// Reducer
export default authSlice.reducer;
